import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import '@fontsource/hanken-grotesk/400.css'
import '@fontsource/hanken-grotesk/500.css'
import '@fontsource/hanken-grotesk/600.css'
import '@fontsource/hanken-grotesk/700.css'
import './index.css'
import App from './App.tsx'
import { scrubUrl } from './lib/scrubUrl'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN && import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Replay só com texto mascarado e mídia bloqueada: saldos, descrições e nomes nunca saem do
    // navegador (LGPD, ADR-010). O replay ainda mostra o layout e os cliques que levaram ao erro.
    Sentry.replayIntegration({ maskAllText: true, maskAllInputs: true, blockAllMedia: true }),
  ],
  tracesSampleRate: 0.2,        // 20% das transações para performance
  replaysSessionSampleRate: 0,  // replay só em erros
  replaysOnErrorSampleRate: 1.0,
  // Links de redefinição de senha e verificação de e-mail levam o token na URL: não podem ir ao Sentry
  beforeBreadcrumb: (crumb) => {
    if (crumb.data?.to) crumb.data.to = scrubUrl(String(crumb.data.to))
    if (crumb.data?.from) crumb.data.from = scrubUrl(String(crumb.data.from))
    if (crumb.data?.url) crumb.data.url = scrubUrl(String(crumb.data.url))
    return crumb
  },
  beforeSend: (event) => {
    if (event.request?.url) event.request.url = scrubUrl(event.request.url)
    if (event.request?.query_string) event.request.query_string = undefined
    return event
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
